<template>

     <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  fill="#000000" stroke="none">
  <path :fill="colorx" d="M2472 4908 l3 -213 85 0 85 0 3 213 2 212 -90 0 -90 0 2 -212z"/>
  <path :fill="colorx" d="M1528 4944 l-68 -34 85 -170 85 -170 73 36 c39 20 73 38 75 39 7 6
  -163 335 -173 335 -5 -1 -40 -17 -77 -36z"/>
  <path :fill="colorx" d="M3422 4814 c-46 -92 -82 -167 -80 -169 2 -1 36 -19 75 -39 l73 -36
  85 170 85 170 -70 35 c-38 19 -73 35 -77 35 -5 0 -46 -75 -91 -166z"/>
  <path :fill="colorx" d="M682 4437 c-29 -29 -52 -57 -52 -62 0 -6 55 -65 123 -133 l122 -122
  63 63 62 62 -123 123 c-67 67 -127 122 -132 122 -6 0 -34 -24 -63 -53z"/>
  <path :fill="colorx" d="M4242 4367 l-122 -122 63 -63 62 -62 123 123 c67 67 122 127 122 132
  0 13 -102 115 -115 115 -6 0 -65 -55 -133 -123z"/>
  <path :fill="colorx" d="M1475 4093 c-159 -14 -326 -119 -400 -251 -68 -122 -60 -33 -141
  -1627 -40 -803 -74 -1477 -74 -1497 l0 -38 -148 0 c-147 0 -149 0 -173 -26
  l-24 -26 0 -290 0 -290 28 -24 28 -24 1989 0 1989 0 28 24 28 24 0 290 0 290
  -24 26 c-24 26 -26 26 -173 26 l-148 0 0 38 c0 20 -34 694 -74 1497 -67 1327
  -76 1465 -94 1520 -57 168 -172 281 -349 342 -44 16 -148 17 -1138 19 -600 0
  -1108 -1 -1130 -3z m2174 -173 c163 -27 272 -140 293 -304 6 -53 149 -2855
  148 -2923 0 -9 -23 -13 -79 -13 l-80 0 -3 229 c-3 227 -3 230 -27 255 l-24 26
  -529 0 -528 0 0 278 0 279 68 26 c166 66 323 207 420 377 17 31 45 98 63 150
  27 80 33 114 37 217 5 134 -4 202 -44 323 -49 151 -160 303 -298 406 -76 58
  -147 94 -256 130 -79 26 -96 28 -250 28 -154 0 -171 -2 -250 -28 -109 -36
  -180 -72 -256 -130 -138 -103 -249 -255 -298 -406 -40 -121 -49 -189 -44 -323
  4 -103 10 -137 37 -217 18 -52 46 -119 63 -150 97 -170 254 -311 421 -377 l67
  -26 0 -279 0 -278 -528 0 -529 0 -24 -26 c-24 -25 -24 -28 -27 -255 l-3 -229
  -80 0 c-56 0 -79 4 -79 13 -1 68 142 2870 148 2923 20 160 131 277 284 303 77
  13 2108 13 2187 1z m-874 -714 c205 -70 356 -219 429 -425 29 -80 31 -96 31
  -221 0 -125 -2 -141 -31 -221 -58 -163 -173 -299 -315 -374 l-69 -36 0 94 0
  94 59 47 c186 146 243 413 135 628 -66 131 -190 229 -339 268 -87 22 -218 11
  -310 -27 -201 -84 -326 -285 -312 -503 9 -147 77 -279 188 -366 l59 -47 0 -93
  0 -94 -27 12 c-16 7 -58 31 -95 55 -325 212 -396 683 -149 989 91 114 217 195
  363 234 108 29 274 23 383 -14z m-73 -338 c182 -84 253 -321 146 -488 l-23
  -35 -5 75 c-6 80 -19 113 -50 130 -25 13 -395 13 -420 0 -31 -17 -44 -50 -50
  -130 l-5 -75 -23 35 c-75 117 -65 282 25 395 92 117 266 156 405 93z m-57
  -1078 l0 -595 -85 0 -85 0 -3 585 c-1 322 0 591 3 598 3 9 27 12 87 10 l83 -3
  0 -595z m1105 -940 l0 -170 -1190 0 -1190 0 0 170 0 170 1190 0 1190 0 0 -170z
  m690 -510 l0 -170 -1880 0 -1880 0 0 170 0 170 1880 0 1880 0 0 -170z"/>
  <path :fill="colorx" d="M1520 3665 l0 -85 733 2 732 3 3 83 3 82 -736 0 -735 0 0 -85z"/>
  <path :fill="colorx" d="M3160 3665 l0 -85 223 0 222 0 45 -895 44 -895 71 1 c38 0 77 3 85 7
  14 6 10 109 -31 917 -32 648 -49 917 -59 935 -7 14 -22 36 -34 48 -44 50 -59
  52 -321 52 l-245 0 0 -85z"/>
  </g>
</svg>

    
</template>
<script>
export default {
  data: () => ({

  }),
  props: {
    colorx: {
      type: String,
      default: '#89899B'
    }
  }
}
</script>

<style lang="css">
</style>
    


// WEBPACK FOOTER //
// src/components/shared/icons/AlarmIcon.vue